module.exports = __webpack_public_path__ + "img/help-guide.1d33f194.jpg";